/** @file The attachments any skin maps into a slot (each attachment once, in skin order). */
import type { Doc, Id } from '@pose2d/format/types';

/** Ids of every attachment that some skin entry maps into `slotId`. */
export function slotAttachments(doc: Doc, slotId: Id): Id[] {
  return [...new Set(Object.values(doc.skins).flatMap((skin) => skin.entries.filter((e) => e.slot === slotId).map((e) => e.attachment)))];
}
